module.exports = __webpack_public_path__ + "img/option-3.8c976ca2.png";